import * as React from "react";
import { observer } from "mobx-react-lite";
import { ModalPlm } from "src/components/ModalPlm";
import { HolderOutlined } from "@ant-design/icons";
import { SortableItemDef, SortableList } from "src/components/SortableList";
import { notification } from "antd";
import { onError } from "src/common/onError";
import styles from "./Mc2PointsOrderModal.module.less";
import { Mc2EntityStore } from "../Mc2EntityStore";

interface PropsMc2PointsOrderModal {
  store: Mc2EntityStore;
}

export const Mc2PointsOrderModal: React.FC<PropsMc2PointsOrderModal> = observer(
  ({ store }) => {
    const srcRows = store.table.rows;
    const srcOrderHash = srcRows.map(({ id }) => id).join(",");
    const [curRows, setCurRows] = React.useState<SortableItemDef[]>([]);
    const curOrderHash = curRows.map(({ key }) => key).join(",");
    const open = store.mode === "pointsOrder";
    React.useEffect(() => {
      if (open)
        setCurRows(
          srcRows.map(({ id, point, description }) => ({
            key: id,
            content: (
              <div
                className={styles.row}
                onDragStart={(e) => {
                  e.currentTarget.classList.add(styles.active);
                }}
              >
                <div className={styles.name}>{point}</div>
                <div className={styles.descr}>{description}</div>
                <div className={styles.icon}>
                  <HolderOutlined />
                </div>
              </div>
            ),
          })),
        );
    }, [srcRows, open]);
    return (
      <ModalPlm
        title="Порядок точек в таблице"
        open={open}
        onCancel={() => store.setMode(null)}
        height="95vh"
        centered
        okText="Изменить"
        okButtonProps={{
          disabled: srcOrderHash === curOrderHash,
          loading: store.taskType === "pointsOrder",
        }}
        onOk={() => {
          store
            .changePointsOrder(curOrderHash.split(","))
            .then(() =>
              notification.success({
                message: "Выполнено изменение порядка строк",
              }),
            )
            .catch(onError);
        }}
      >
        <SortableList
          items={curRows}
          onChange={(res) => {
            setCurRows(res);
          }}
          containerClassName={styles.list}
        />
      </ModalPlm>
    );
  },
);
